import { render, staticRenderFns } from "./NewReservation.vue?vue&type=template&id=231efdf9&scoped=true&"
import script from "./NewReservation.vue?vue&type=script&lang=js&"
export * from "./NewReservation.vue?vue&type=script&lang=js&"
import style0 from "./NewReservation.vue?vue&type=style&index=0&id=231efdf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231efdf9",
  null
  
)

export default component.exports